import {
  RedoPrintJobBaseSchema,
  RedoPrintJobDataSchema,
} from "@redotech/redo-fulfillment-group-common/print-job";
import * as zExt from "@redotech/rpc/ext";
import { PrintQueueStatusSchema } from "./watch-print-queue";

import * as z from "zod";

// Create a schema that matches input for creating print jobs
export const EnqueuePrintJobItemSchema = z.intersection(
  RedoPrintJobDataSchema,
  z.object({
    ...RedoPrintJobBaseSchema.omit({
      _id: true,
      userId: true,
      teamId: true,
      status: true,
    }).shape,
    _id: zExt.objectId().optional(),
  }),
);

export const enqueuePrintJobs = {
  name: "enqueuePrintJobs" as const,
  input: z.array(EnqueuePrintJobItemSchema),
  output: PrintQueueStatusSchema,
};

export type EnqueuePrintJobsInput = z.infer<typeof enqueuePrintJobs.input>;
export type EnqueuePrintJobItem = z.infer<typeof EnqueuePrintJobItemSchema>;
